/**
 * Created by Bart Decorte
 * Date: 2019-07-11
 * Time: 15:42
 */
import TablesShowMatrix from './_partials/TablesShowMatrix';
import DirtyUnloadNotifier from '../../utils/DirtyUnloadNotifier';
import SubmitButtonManager from '../../helpers/SubmitButtonManager';

class TablesShowInline extends TablesShowMatrix {
  constructor() {
    const dirtyUnloadNotifier = new DirtyUnloadNotifier(
      '.js-dirty-unload-notify'
    );
    const $form = $('.js-entry-form');
    super({ $root: $form, dirtyUnloadNotifier });
    this.$form = $form;
    this.dirtyUnloadNotifier = dirtyUnloadNotifier;
    this.submitButtonManager = new SubmitButtonManager({
      buttonSelector: '.js-btn-save, .js-btn-save-return',
      $form: this.$form,
      stateEmitter: this,
      onActualSubmit: () => {
        this.submitForm();
      },
    });
  }

  keyBindings() {
    const bindings = super.keyBindings();
    const scope = this;
    return {
      ...bindings,
      'mod+s': (ev) => scope.lModS(ev),
    };
  }

  lModS(ev) {
    if (ev.preventDefault) {
      ev.preventDefault();
    }
    this.submitButtonManager.submitWhenIdle('save');
    return false;
  }

  submitForm() {
    this.dirtyUnloadNotifier.lFormSubmitted();
    const form = this.$form.get(0);

    // Event needs to actually be triggered to make CKeditor write to the textarea, does not submit the form
    form.dispatchEvent(new Event('submit'));

    // This makes the submit happen
    document.createElement('form').submit.call(form);
  }
}

export default TablesShowInline;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/TablesShowInline.js